import type { ReactElement } from "react";

import { TimeoutErrorGate } from "app/pages/sales-intelligence/common-components/error-state/components/TimeoutErrorGate";
import SearchResultsTableContainer from "app/pages/sales-intelligence/modules/apps-search/containers/SearchResultsTable/SearchResultsTableContainer";
import type { AppsSearchRequestDto } from "app/pages/sales-intelligence/modules/apps-search/types/dto";
import { createSearchResultsTableDataFromDto } from "app/pages/sales-intelligence/modules/apps-search/utils/table";
import { useAppsSearchResultsQuery } from "app/pages/sales-intelligence/pages/advanced-search/query/queries/useAppsSearchResultsQuery";

interface IProps {
    searchRequestDto: AppsSearchRequestDto;
}

const AppsSearchResultsTableContainer = ({ searchRequestDto }: IProps): ReactElement => {
    const { data, isFetching, isPending, isError, error } = useAppsSearchResultsQuery(
        searchRequestDto,
        createSearchResultsTableDataFromDto,
    );

    return (
        <TimeoutErrorGate
            isError={isError}
            error={error}
        >
            <SearchResultsTableContainer
                data={data}
                isLoading={isFetching || isPending}
            />
        </TimeoutErrorGate>
    );
};

export default AppsSearchResultsTableContainer;
